import { form } from "sap/ui/layout/library";

export default {
	formatValue: (value: string) => {
		return value?.toUpperCase();
	},

	calculateTotalPrice: (
		quantity: number,
		price: number,
		currency: string = "EUR",
	) => {
		console.log("Quantity:", quantity, typeof quantity);
		console.log("Price:", price, typeof price);
		// Handle cases where values might be undefined or null
		const qty = quantity || 0;
		const prc = price || 0;

		const total = qty * prc;
		console.log("Total Price:", total);

		if (!currency) {
			currency = "EUR"; // Default currency
		}

		// Format the result with 2 decimal places
		return `${currency} ${total.toFixed(2)}`;
	},
	formatDate: (dateString: string) => {
		if (!dateString) {
			return "";
		}
		const date = new Date(dateString);
		if (isNaN(date.getTime())) {
			return dateString;
		}

		return date.toLocaleDateString("de-DE"); //TODO: localisation!!
	},
	formatCurrency(value: number | string, currency: string = "EUR"): string {
		console.log("Formatting Currency:", value, currency);
		if (value === null || value === undefined || value === "") {
			return "";
		}

		const numValue = typeof value === "string" ? parseFloat(value) : value;

		if (isNaN(numValue)) {
			return "";
		}

		if (!currency) {
			currency = "EUR"; // Default currency
		}

		// Format with two decimal places
		const formattedNumber = numValue.toFixed(2);
		console.log("Formatted Currency:", `${currency} ${formattedNumber}`);

		return `${currency} ${formattedNumber}`;
	},
};
